(function(){
var d=document,W=window,q=function(s,c){return (c||d).querySelector(s)},qa=function(s,c){return [].slice.call((c||d).querySelectorAll(s))};

/* ---------- product gallery ---------- */
var gal=q('[data-gal]');
if(gal){
var tabs=qa('[data-gal-tab]',gal),panes=qa('[data-gal-pane]',gal);
function show(id){
tabs.forEach(function(t){t.setAttribute('aria-selected',String(t.dataset.galTab===id))});
panes.forEach(function(p){
var on=p.dataset.galPane===id;p.classList.toggle('is-on',on);p.setAttribute('aria-hidden',String(!on));
if(on&&p.dataset.embed&&!q('iframe',p)){var f=d.createElement('iframe');f.src=p.dataset.embed;f.title='360° view of this diamond';f.loading='lazy';f.allow='fullscreen';p.innerHTML='';p.appendChild(f)}
});
}
tabs.forEach(function(t){t.addEventListener('click',function(){show(t.dataset.galTab)})});
}

/* ---------- mobile sticky add-to-cart ---------- */
var atc=q('[data-atc]'),bar=q('[data-mbar]');
if(atc&&bar&&'IntersectionObserver' in W){
new IntersectionObserver(function(e){bar.classList.toggle('is-on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(atc);
var mb=q('[data-mbar-btn]',bar);mb&&mb.addEventListener('click',function(){var b=q('.single_add_to_cart_button',atc);if(b)b.click();else W.scrollTo({top:atc.getBoundingClientRect().top+scrollY-120,behavior:'smooth'})});
}

/* ---------- stone enquiry pop-up ---------- */
var enq=q('[data-enq]');
if(enq){
var ef=q('[data-enq-form]',enq),emsg=q('[data-enq-msg]',enq),edone=q('[data-enq-done]',enq),lastFocus=null;
var modal=typeof enq.showModal==='function';
function eOpen(e){if(e)e.preventDefault();lastFocus=d.activeElement;if(modal)enq.showModal();else enq.setAttribute('open','');d.documentElement.style.overflow='hidden';setTimeout(function(){var i=q('input[name=name]',ef);if(i&&!matchMedia('(pointer:coarse)').matches)i.focus()},60)}
function eClose(){if(modal&&enq.open)enq.close();else enq.removeAttribute('open');d.documentElement.style.overflow='';if(lastFocus)lastFocus.focus()}
qa('[data-enq-open]').forEach(function(a){a.addEventListener('click',eOpen)});
qa('[data-enq-close]',enq).forEach(function(b){b.addEventListener('click',eClose)});
enq.addEventListener('click',function(e){if(e.target===enq)eClose()});
enq.addEventListener('close',function(){d.documentElement.style.overflow=''});
ef.addEventListener('submit',function(e){
e.preventDefault();
if(!ef.name.value.trim()||!/^\S+@\S+\.\S+$/.test(ef.email.value)){emsg.textContent='Please add your name and a valid email.';emsg.className='cc-enq__msg is-err';(ef.name.value.trim()?ef.email:ef.name).focus();return}
var b=q('.cc-enq__go',ef);b.disabled=true;b.textContent='Sending…';emsg.textContent='';emsg.className='cc-enq__msg';
window.ccContact(ef,ef.dataset.subject).then(function(x){
if(!x.ok)throw new Error('Could not send. Please email us.');
ef.hidden=true;edone.hidden=false;q('button',edone).focus();
}).catch(function(err){b.disabled=false;b.innerHTML='Send enquiry <span aria-hidden="true">→</span>';emsg.textContent=err.message||'Could not send. Please email us.';emsg.className='cc-enq__msg is-err'});
});
}

/* ---------- listing filters ---------- */
var form=q('[data-plp-form]');
if(!form)return;
var results=q('[data-plp-results]'),timer=0,ctrl=null;

function fmt(v,kind){return kind==='price'?'$'+Math.round(v).toLocaleString():(+v).toFixed(2)}
function initRanges(scope){
qa('.cc-range',scope).forEach(function(r){
var a=qa('input[type=range]',r),n=qa('.cc-range__nums input',r.parentNode),fill=q('.cc-range__fill',r),out=q('output',r.parentNode),kind=r.dataset.kind;
var min=+a[0].min,max=+a[0].max;
function paint(){
var lo=Math.min(+a[0].value,+a[1].value),hi=Math.max(+a[0].value,+a[1].value);
fill.style.left=((lo-min)/(max-min)*100)+'%';fill.style.right=(100-(hi-min)/(max-min)*100)+'%';
if(out)out.textContent=fmt(lo,kind)+' – '+fmt(hi,kind);
return [lo,hi];
}
/* carat: Shopify filters ccs.carat_band by exact value, so the slider ticks the bands it covers and snaps to their edges */
function snap(){if(kind!=='carat')return;var v=paint(),bx=qa('[data-band-lo]',r.parentNode),full=v[0]<=min&&v[1]>=max,lo=Infinity,hi=-Infinity;
bx.forEach(function(c){var bl=+c.dataset.bandLo,bh=+c.dataset.bandHi;c.checked=!full&&bl<=v[1]&&bh>v[0];if(c.checked){lo=Math.min(lo,bl);hi=Math.max(hi,bh-0.01)}});
if(full||lo===Infinity)return;lo=Math.max(min,lo);hi=Math.min(max,hi);a[0].value=lo;a[1].value=hi;v=paint();n[0].value=v[0].toFixed(2);n[1].value=v[1].toFixed(2)}
a.forEach(function(x){x.addEventListener('input',function(){var v=paint();n[0].value=kind==='price'?Math.round(v[0]):v[0].toFixed(2);n[1].value=kind==='price'?Math.round(v[1]):v[1].toFixed(2)});x.addEventListener('change',function(){snap();queue()})});
n.forEach(function(x,i){x.addEventListener('change',function(){var v=Math.max(min,Math.min(max,+x.value||0));a[i].value=v;paint();snap();queue()})});
paint();
});
}
function buildURL(){
var p=new URLSearchParams();
new FormData(form).forEach(function(v,k){if(typeof v==='string'&&v!=='')p.append(k,v)});
qa('.cc-range',form).forEach(function(r){
if(r.dataset.kind==='carat')return;
var a=qa('input[type=range]',r),n=qa('.cc-range__nums input',r.parentNode),lo=Math.min(+a[0].value,+a[1].value),hi=Math.max(+a[0].value,+a[1].value);
p.delete(n[0].name);p.delete(n[1].name);
if(lo>+a[0].min)p.set(n[0].name,n[0].value);
if(hi<+a[0].max)p.set(n[1].name,n[1].value);
});
var s=q('select[name=sort_by]',form);if(s&&s.value===s.dataset.default)p.delete('sort_by');
var base=form.getAttribute('action');
var qs=p.toString().replace(/%2C/g,',');
return base+(qs?'?'+qs:'');
}
function countActive(){
var n=qa('input[type=checkbox][data-group]:checked',form).length;
qa('.cc-range',form).forEach(function(r){var a=qa('input[type=range]',r);if(Math.min(+a[0].value,+a[1].value)>+a[0].min||Math.max(+a[0].value,+a[1].value)<+a[0].max)n++});
qa('[data-fcount]').forEach(function(el){el.textContent=n;el.dataset.n=n});
}
function load(url,replaceForm){
if(ctrl)ctrl.abort();ctrl='AbortController' in W?new AbortController():null;
results.classList.add('is-loading');
fetch(url,{headers:{'X-CC-Ajax':'1'},signal:ctrl&&ctrl.signal,credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
var doc=new DOMParser().parseFromString(html,'text/html');
['[data-plp-results]','[data-plp-count]','[data-plp-active]','[data-plp-show]'].forEach(function(s){var a=q(s),b=q(s,doc);if(a&&b)a.innerHTML=b.innerHTML});
if(replaceForm){var nf=q('[data-plp-form]',doc);if(nf){form.innerHTML=nf.innerHTML;initRanges(form)}}
countActive();
results.classList.remove('is-loading');
if(url!==location.pathname+location.search&&url!==location.href)history.pushState({cc:1},'',url);
}).catch(function(e){if(e.name!=='AbortError')location.href=url});
}
function queue(){countActive();clearTimeout(timer);timer=setTimeout(function(){load(buildURL(),false)},320)}

form.addEventListener('change',function(e){if(!e.target.matches('input[type=range],.cc-range__nums input'))queue()});
form.addEventListener('submit',function(e){e.preventDefault();load(buildURL(),false)});
d.addEventListener('click',function(e){
var a=e.target.closest('[data-plp-active] a,[data-plp-results] .cc-pages a');
if(a){e.preventDefault();load(a.href,true);var top=q('[data-plp-top]');if(top&&a.closest('.cc-pages'))W.scrollTo({top:top.getBoundingClientRect().top+scrollY-120,behavior:'smooth'})}
});
W.addEventListener('popstate',function(){load(location.href,true)});

/* fancy shape families (delegated: survives form refresh) */
d.addEventListener('click',function(e){
var t=e.target.closest('[data-fam-tab]'),all=e.target.closest('[data-fam-all]');
if(!t&&!all)return;
var box=(t||all).closest('[data-fam]');if(!box)return;
var tiles=qa('.cc-fshape--fancy',box),btn=q('[data-fam-all]',box);
if(all){tiles.forEach(function(x){x.hidden=false});all.hidden=true;qa('[data-fam-tab]',box).forEach(function(b){b.setAttribute('aria-selected','false')});return}
var f=t.dataset.famTab;
qa('[data-fam-tab]',box).forEach(function(b){b.setAttribute('aria-selected',String(b===t))});
tiles.forEach(function(x){x.hidden=(' '+x.dataset.fam+' ').indexOf(' '+f+' ')<0});
if(btn)btn.hidden=f!=='all';
});
var more=q('[data-more]'),morePanel=q('.cc-fpanels--more');
more&&more.addEventListener('click',function(){var h=!morePanel.hidden;morePanel.hidden=h;more.setAttribute('aria-expanded',String(!h));more.textContent=h?'More filters +':'Fewer filters −'});

var drawer=q('[data-drawer]');
function openD(o){if(!drawer)return;drawer.classList.toggle('is-open',o);d.body.style.overflow=o?'hidden':''}
qa('[data-drawer-open]').forEach(function(b){b.addEventListener('click',function(){openD(true)})});
qa('[data-drawer-close]').forEach(function(b){b.addEventListener('click',function(){openD(false)})});
d.addEventListener('keydown',function(e){if(e.key==='Escape')openD(false)});

function loadMore(){
var old=q('[data-plp-results] .cc-loadmore');if(old)old.remove();
var pages=q('[data-plp-results] .cc-pages'),next=pages&&q('a.next',pages);
if(!next)return;
var wrap=d.createElement('div');wrap.className='cc-loadmore';var b=d.createElement('button');b.type='button';b.textContent='Show more stones';wrap.appendChild(b);pages.parentNode.insertBefore(wrap,pages);
b.addEventListener('click',function(){b.disabled=true;b.textContent='Loading…';
fetch(next.href,{headers:{'X-CC-Ajax':'1'},credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){
var doc=new DOMParser().parseFromString(h,'text/html'),grid=q('[data-plp-results] .cc-stones'),ng=q('[data-plp-results] .cc-stones',doc),np=q('[data-plp-results] .cc-pages',doc);
if(grid&&ng)[].slice.call(ng.children).forEach(function(c){grid.appendChild(c)});
if(np)pages.innerHTML=np.innerHTML;else pages.remove();
loadMore();
}).catch(function(){location.href=next.href})});
}
new MutationObserver(function(){if(!q('[data-plp-results] .cc-loadmore'))loadMore()}).observe(results,{childList:true});
initRanges(form);countActive();loadMore();
})();
